import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  // State to hold the authentication token
  const [token, setToken_] = useState(localStorage.getItem("token"));

  // State to hold user details (without company info)
  const [userdetails, setUserDetails_] = useState(() => {
    try {
      const stored = localStorage.getItem("userdetails");
      return stored ? JSON.parse(stored) : null;
    } catch (err) {
      console.error("Failed to parse userdetails from localStorage:", err);
      localStorage.removeItem("userdetails");
      return null;
    }
  });



  /**
   * isAuthLoading — true during the very first render while React is
   * committing the initial hydrated state from localStorage.
   *
   * ProtectedRoute reads this flag and renders nothing (no redirect) until
   * it becomes false, preventing the race condition where group_names is
   * seen as empty before the context value propagates to consumers.
   */
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  // Flip isAuthLoading off after the first committed render so that all
  // auth state (token, userdetails, activeCompany) is guaranteed to be
  // stable before any route guard runs its access check.
  useEffect(() => {
    setIsAuthLoading(false);
  }, []); // empty deps ⟹ runs exactly once, after mount




  // Function to set the authentication token
  const setToken = (newToken) => {
    setToken_(newToken);
  };

  // Function to set user details
  const setUserDetails = (userdetails) => {
    setUserDetails_(userdetails);
  };



  // Effect to handle localStorage updates
  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }

    if (userdetails && typeof userdetails === 'object') {
      localStorage.setItem('userdetails', JSON.stringify(userdetails));
    } else {
      localStorage.removeItem('userdetails');
    }
  }, [token, userdetails]);

  const logout = () => {
    setToken_(null);
    setUserDetails_(null);
    localStorage.removeItem('token');
    localStorage.removeItem('userdetails');
  };

  // Memoized value of the authentication context
  const contextValue = useMemo(
    () => ({
      token,
      setToken,
      userdetails,
      setUserDetails,
      logout,
      isAuthLoading,
    }),
    [token, userdetails, isAuthLoading]
  );

  // Provide the authentication context to the children components
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthProvider;

























//import { createContext, useContext, useEffect, useMemo, useState } from "react";
//
//const AuthContext = createContext();
//
//const AuthProvider = ({ children }) => {
//  // State to hold the authentication token
//  const [token, setToken_] = useState(localStorage.getItem("token"));
//
//  const [userdetails, setUserDetails_] = useState(() => {
//  try {
//    const stored = localStorage.getItem("userdetails");
//    return stored ? JSON.parse(stored) : null;
//  } catch (err) {
//    console.error("Failed to parse userdetails from localStorage:", err);
//    localStorage.removeItem("userdetails"); // Optional: clear bad data
//    return null;
//  }
//});
//
//  // Function to set the authentication token
//  const setToken = (newToken) => {
//    setToken_(newToken);
//  };
//
//  const setUserDetails = (userdetails) => {
//    setUserDetails_(userdetails);
//  };
//
//  useEffect(() => {
//    if (token) {
//      localStorage.setItem('token',token);
//    } else {
//      localStorage.removeItem('token')
//    }
//    if (userdetails && typeof userdetails === 'object') {
//  localStorage.setItem('userdetails', JSON.stringify(userdetails));
//} else {
//  localStorage.removeItem('userdetails');
//}
//  }, [token, userdetails]);
//
//  // Memoized value of the authentication context
//  const contextValue = useMemo(
//    () => ({
//      token,
//      setToken,
//      userdetails,
//      setUserDetails,
//    }),
//    [token, userdetails]
//  );
//
//  // Provide the authentication context to the children components
//  return (
//    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
//  );
//};
//
//export const useAuth = () => {
//  return useContext(AuthContext);
//};
//
//export default AuthProvider;
//
